import React from 'react';
import Carousel from 'components/shared/Carousel';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchHomepagePackages } from 'stores/Homepage/homepageActions';


const MainPackages = React.memo(props => {
  const { packages, fetchHomepagePackages, packagesFetched } = props;
  React.useEffect(() => {
    if (!packagesFetched) {
      fetchHomepagePackages();
    }
  }, [fetchHomepagePackages, packagesFetched])

  let content = (
    <Carousel id="main_packages_slider" type="SlidePackage" empty={true} />
  );


  if (packagesFetched && packages.length === 0) {
    content = <div>Something wentWrong</div>
  }

  if (packages) {
    content = (
      <Carousel
        id="main_packages_slider"
        large={1}
        mid={1}
        small={1}
        show_dots={true}
        direction={props.direction}
        type="SlidePackage"
        initial_shift={0}
        show_next_prev_buttons={true}
        slides={packages}
      />
    );
  }

  return (
    <div className="main-packages dark-bg">
      <div className="container">{content}</div>
    </div>
  );
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { fetchHomepagePackages },
    dispatch
  );
};
const mapStateToProps = state => {
  return {
    direction: state.layout.direction,
    packages: state.homePage.packages,
    packagesLoading: state.homePage.packagesLoading,
    packagesFetched: state.homePage.packagesFetched
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainPackages);